import {
  SET_USERS,
  GET_USERS,
  AdminProps,
  GET_USERS_ORDERS,
  SET_USERS_ORDERS,
  DELETE_PHOTO,
  SET_COOKMEALS,
  GET_COOKMEALS,
  GET_ADVERTISEMENT,
  SET_ADVERTISEMENT,
  ADD_ADVERTISEMENT,
  DELETE_ADS,
  AdsState,
} from './types';

export const getAllUsers = () => ({ type: GET_USERS });
export const setAllUsers = (users: AdminProps[]) => ({
  type: SET_USERS,
  users,
});

export const getOrders = (key: string, accountType: string) => ({
  type: GET_USERS_ORDERS,
  key,
  accountType,
});

export const setAllOrders = (orders: AdminProps[]) => ({
  type: SET_USERS_ORDERS,
  orders,
});

export const handleDelete = (key: string, deletetype: string) => ({
  type: DELETE_PHOTO,
  key,
  deletetype,
});

export const setCookMeals = (meals: AdminProps[]) => ({
  type: SET_COOKMEALS,
  meals,
});

export const getCookMeals = (cookid?: string) => ({
  type: GET_COOKMEALS,
  cookid,
});

export const uploadAds = (banner: AdsState) => ({
  type: ADD_ADVERTISEMENT,
  banner,
});

export const setAds = (advertisement: AdminProps[]) => ({
  type: SET_ADVERTISEMENT,
  advertisement,
});

export const deleteAds = (id: string) => ({
  type: DELETE_ADS,
  id,
})

export const getAds = () => ({ type: GET_ADVERTISEMENT });
